import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=c85d9768&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=c85d9768&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85d9768",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c85d9768')) {
      api.createRecord('c85d9768', component.options)
    } else {
      api.reload('c85d9768', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=c85d9768&scoped=true&", function () {
      api.rerender('c85d9768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2I3yPMKth5714/JS/teamMember.vue"
export default component.exports